import { brand, media } from "@/config/site";
import { waMessages } from "@/lib/whatsapp";
import MediaImage from "@/components/feature/MediaImage";
import WhatsAppLink from "@/components/feature/WhatsAppLink";

export default function Hero() {
  return (
    <section className="relative overflow-hidden">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-2 lg:gap-16 lg:py-20">
        <div className="flex flex-col justify-center">
          <p className="animate-fade-up text-xs uppercase tracking-[0.28em] text-accent-600 md:text-sm">
            {brand.location}
          </p>
          <h1 className="animate-fade-up mt-5 font-heading text-[40px] leading-[1.06] text-primary-800 md:text-6xl lg:text-[72px]">
            Size yakışan dokunuş, size özel bir deneyim.
          </h1>
          <p className="animate-fade-up mt-6 max-w-md text-base leading-relaxed text-foreground-600 md:text-lg">
            Saç tasarımından gelin hazırlığına, güzellik ve bakım hizmetlerimize kadar gülaYonar'da
            kendinize zaman ayırın.
          </p>

          <div className="animate-fade-up mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <WhatsAppLink
              message={waMessages.general}
              label="WhatsApp'tan Randevu Talebi"
              variant="primary"
              size="lg"
              sourceSection="hero"
            />
            <a
              href="#hizmetler"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-800 px-7 py-4 text-base font-medium text-primary-800 transition-colors hover:bg-primary-800 hover:text-background-50"
            >
              Hizmetleri Keşfet
              <i className="ri-arrow-down-line" aria-hidden="true"></i>
            </a>
          </div>

          <p className="animate-fade-up mt-8 text-sm tracking-[0.2em] text-foreground-500">
            Saç • Güzellik • Makyaj
          </p>
        </div>

        <div className="relative">
          <div className="aspect-[4/5] w-full overflow-hidden rounded-lg bg-background-200">
            <MediaImage
              src={media.heroMain}
              alt="gülaYonar'da şekillendirilmiş doğal dalgalı saç görünümü"
              eager
              className="h-full w-full"
            />
          </div>
          <div className="absolute -bottom-6 -left-4 w-40 overflow-hidden rounded-lg border-4 border-background-100 md:-left-8 md:w-52">
            <div className="aspect-[4/5] w-full">
              <MediaImage
                src={media.heroDetail}
                alt="Zarif gelin topuzu detay görünümü"
                className="h-full w-full"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}